import WebFont from 'webfontloader';
import { TWhiteLabelStore } from '../white-label.model';
import { EWhiteLabelFont } from '../white-label-fonts.enum';
import { getFontName } from './get-font-name';

export function setFontFamily(themeWrapper: HTMLBodyElement, whiteLabel: TWhiteLabelStore): void {
  if (whiteLabel.data.fontFamily === EWhiteLabelFont.FUTURA_PT) {
    // Not a WebFont, but available by default anyway
    themeWrapper.style.setProperty('--fontFamily', 'FuturaPTBook');

    return;
  }

  const fontFamily = getFontName(whiteLabel.data.fontFamily).replace(/ /g, '+');

  WebFont.load({
    fontloading: () => {},
    fontactive: (familyName) => {
      themeWrapper.style.setProperty('--fontFamily', familyName);
    },
    google: {
      families: [fontFamily],
    },
  });
}
